import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import "@/i18n"; // Initialize i18n
import App from "@/App";

// Wrapper component that removes SSR content after React mounts
// This prevents duplicate content for JavaScript-enabled users
function RootApp() {
  React.useEffect(() => {
    // Remove SSR content div after React has rendered
    // If JavaScript fails/disabled, SSR content stays visible for crawlers
    const ssrContent = document.getElementById("ssr-content");
    if (ssrContent) {
      ssrContent.remove();
    }
  }, []);

  return <App />;
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <RootApp />
  </React.StrictMode>,
);
